export const uppercaseFirstLetter = str => str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase()

export const capitaliseEveryWord = str => {
  const arr = str?.split(' ')

  for (let i = 0; i < arr?.length; i++) {
    // splits the word into sub-words if they contains hyphens
    const hyphenatedWords = arr[i]?.split('-')

    // Capitalize each sub-word
    for (let j = 0; j < hyphenatedWords.length; j++) {
      hyphenatedWords[j] = uppercaseFirstLetter(hyphenatedWords[j])
    }

    arr[i] = hyphenatedWords.join('-')
  }

  return arr?.join(' ')
}
export const capitalizeWordInText = ({ text, word }) => {
  const pattern = new RegExp(`\\b${word}\\b`, 'gi')
  return text.replace(pattern, match => match.toUpperCase())
}
